import { defaultColors } from '@toggle/chart';
import { themes } from '@toggle/design-system';

import { useThemeStore } from '~/components/theme-controller/stores/useThemeStore';

export type UseChartThemeReturn = ReturnType<typeof useChartTheme>;

type Variant = 'default' | 'soft' | 'multiline';

const HEX_COLOR_FILTER = /[^a-z0-9#,]/g;

export const useChartTheme = (variants: Variant[] = ['default']) => {
  const themeName = useThemeStore(state => state.themeName);
  const themeColors = themes[themeName];

  const multi = themeColors['--chart-colors-list']
    .replace(HEX_COLOR_FILTER, '')
    .split(',');

  return {
    colors: {
      ...defaultColors,
      bars: {
        up: themeColors['--viz-bullish'],
        down: themeColors['--viz-bearish'],
      },
      threshold: {
        bullish: themeColors['--viz-bullish-soft'],
        bearish: themeColors['--viz-bearish-soft'],
      },

      ...(variants.includes('soft') && {
        border: {
          default: themeColors['--border-soft'],
          soft: themeColors['--border-soft'],
          hover: themeColors['--border-hover'],
        },
      }),

      ...(variants.includes('multiline') && {
        multi: Array(4).fill(multi).flat(),
      }),
    },
  };
};
